 import { GetDatasourceListResponse } from "services/interface";
import styled from "@emotion/styled";
import { Button, Divider, Form, Input, Space } from "antd";
import { FC } from "react";
 
interface OrderDescriptionFormProps {
  handleSearchMobile: (tel: string) => void;
}

const OrderDescriptionForm: FC<OrderDescriptionFormProps> = ({ handleSearchMobile }) => {

  const onFinish = (values: any) => {
    const mobileValue = values.mobile;
     handleSearchMobile(mobileValue);
  }
  const [form] = Form.useForm();


  return (
    <Form form={form} onFinish={onFinish}>
      <FormWrapper>
        <FormItems
          labelAlign="left"
          label="ค้นหาลูกค้า"
          name="mobile"
          rules={[{ required: true, message: "กรุณากรอกเบอร์โทรศัพท์ ชื่อ อีเมลล์" }]}
        >
          <Space.Compact>
            <Input
              style={{ height: '32px', width: '300px' }}
              placeholder="ค้นหา เบอร์โทรศัพท์ ชื่อ อีเมลล์"
            />
            <Button type="primary" htmlType="submit">ค้นหา</Button>
            {/* <Button type="default" danger >X ล้างข้อมูล</Button> */}
          </Space.Compact>

        </FormItems>

       </FormWrapper>

    </Form>
  );
};

export default OrderDescriptionForm;

const FormItems = styled(Form.Item)`
  margin-bottom: 10px;
  width: 100%;
`

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 2px 20px;
  background-color: #ffffffff;
`;

